<template>
    <div class="body Unconfirmed" id="telemetering" >
        <div class="header">
            <Area width="1473" @changeSite="changeSite" @initAreaId="getInitAreaId" />
        </div>
        <div class="search">
            <Search @makeSure="makeSure" @searchInfo="searchInfo"></Search>
        </div>
        <div class="table">
            <Table :data="data"  :size="size" :ListInfo="ListInfo" :isClear="isClear"
                @isClear="isClear=false"
                @handleCurrentChange="handleCurrentChange"
                @handleSelectionChange="handleSelectionChange"
                @showDetail="showDetail" @setCheck="setCheck">
            </Table>
        </div>
        <Details v-if="isShowDetail" :dialogVisible="isShowDetail" :status="accidentDetailStatus" :detail="detail"
            @closeDetail="closeDetail" />
    </div>
</template>

<script>
    import Area from '../../components/OperatingEnvironment/Area';
    import Search from '../../components/accidentManagement/UnconfirmedEvent/Search.vue';
    import Table from '../../components/accidentManagement/UnconfirmedEvent/Table.vue';
    import Details from '../../components/accidentManagement/UnconfirmedEvent/Details.vue';

    import {
        GetDetailList,
        GetAccidentDetailForId,
        GetAccidentValue,
        SetAccidentCheck,
        GetAlarmEvent,
        SetArticleCheck,
        GetHistory
    } from '../../api/accident';
    export default {
        data() {
            return {
                data:[],
                ListInfo:{},
                areaId: -1,
                size:10,
                isShowDetail:false,
                detail:{},
                accidentDetailStatus: 'loaded',
                isClear:false,
                tableSelect:[],
                searchData:{
                    start:"",
                    end:"",
                    identTypeClass:"",
                    IncidentClassificationClass:""
                }
            }
        },
        components: {
            Area,
            Search,
            Table,
            Details
        },
        mounted(){
            
        },
        methods: {
            searchInfo(val){
                this.searchData = val
            },
            handleSelectionChange(val){
                this.tableSelect = val.map(e=>e.id)
            },
            makeSure(data){
                if(this.tableSelect.length>0){
                    this.$confirm('确认已处理勾选事件?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(async(action) => {
                            this.isClear = data
                            let alarmIds = this.tableSelect.join(',')
                            let result = await SetAccidentCheck([alarmIds])
                            if(result.data.code==200){
                                this.$message({
                                    message: '确认成功!',
                                    type: 'success'
                                });
                                this.getData()
                            }


                        }).catch((action) => {
                           
                        });
                }else{
                    this.$message('请勾选！');
                }
                
            },
            // 关闭详情页
            async closeDetail(id, state, change) {
                this.isShowDetail = false;
                if (state && change) {
                    let response = await SetAccidentCheck([id]);
                    if (response.data.code === 200 && response.data.status === true && response.data.msg ===
                        '状态更新成功') {
                        let index = this.data.findIndex(item => item.id == id)
                        this.$set(this.data[index], 'alarm_check', true)
                        return true;
                    }
                    return false;
                }
            },
            async showDetail(code){
                this.isShowDetail = true;
                this.detail = await this.getAccidentDetail(code);
            },
            // Mapper到详情页的指定数据格式
            accidentDetailMapper(data) {
                return {
                    loopId: data.loop_id,
                    img: data.device_img,
                    name: data.loop_name,
                    deviceName: data.device_name,
                    position: data.area_name,
                    code: data.id,
                    classify: data.alarm_event_type,
                    type: data.alarm_type_desc,
                    start: data.start_time,
                    end: data.end_time,
                    description: data.alarm_type_desc,
                    node: data.node,
                    check: data.alarm_check,
                    realName: data.real_name,
                    event_name: data.event_name,
                    device: data.device_details,
                    loop_type:data.loop_type,
                    incident_type:data.incident_type,
                    incident_classification:data.incident_classification
                }
            },
            // Mapper到详情页快照数据的指定格式
            accidentValueMapper(data, node,type) {
                let snapshot = data.results[0].series;
                // console.log(snapshot);
                if (snapshot) {
                    let temps = snapshot.map(item => {
                        // console.log(item,'我是item')
                        return [item.tags.node, item.values[0][1]];
                    });
                    let map = new Map(temps);
                    return this.accidentValueFormat(map, node,type);
                } else {
                    return []
                }

            },
            // 快照数据的指定格式
            accidentValueFormat(map, node,type) {
                if(type.classify=='TELEMETRY_OVERRUN'&&type.loop_type=='TRANSFORMER'){
                    return [{
                            title: '温度',
                            unit: '℃',
                            isDangerous: ['Temperature_A', 'Temperature_B', 'Temperature_C'].includes(node),
                            value: [{
                                    name: 'A',
                                    value: map.get('Temperature_A')?map.get('Temperature_A').toFixed(2):map.get('Temperature_A'),
                                    isDangerous: ['Temperature_A'].includes(node),
                                },
                                {
                                    name: 'B',
                                    value: map.get('Temperature_B')?map.get('Temperature_B').toFixed(2):map.get('Temperature_B'),
                                    isDangerous: ['Temperature_B'].includes(node),
                                },
                                {
                                    name: 'C',
                                    value: map.get('Temperature_C')?map.get('Temperature_C').toFixed(2):map.get('Temperature_C'),
                                    isDangerous: ['Temperature_C'].includes(node),
                                },
                                // {name: '均', value: map.get('Vvavg')},
                            ]
                        }, {
                            title: '风机状态',

                            isDangerous: [this.fengji].includes(node),

                            value: [{
                                isDangerous: [this.fengji].includes(node),
                                value: map.get(this.fengji)
                            }]
                        },{
                            title: '负载',
                            unit: 'V',
                            value: (map.get('P') / 1000)?(map.get('P') / 1000).toFixed(2):(map.get('P') / 1000),
                            value: [{
                                isDangerous: ['P'].includes(node),
                                value: (map.get('P') / 1000).toFixed(2)
                            }, ]
                        }, {
                            title: '负载率',
                            unit: '%',
                            value: (map.get('P') / 1000)?(map.get('P') / 1000).toFixed(2):(map.get('P') / 1000),
                            value: [{
                                isDangerous: this.fengji.includes(node),
                                value: map.get(this.fengji)?map.get(this.fengji).toFixed(2):map.get(this.fengji)
                            }, ]
                        },
                        {
                            title: '容量',
                            unit: 'kVA',
                            value: (map.get('P') / 1000)?(map.get('P') / 1000).toFixed(2):(map.get('P') / 1000),
                            value: [{
                                isDangerous: this.fengji.includes(node),

                            }, ]
                        }
                    ]   
                }else{
                    return [{
                        title: '三相相电压',
                        unit: 'V',
                        isDangerous: ['Ua', 'Ub', 'Uc', 'Vvavg'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('Ua')?map.get('Ua').toFixed(2):map.get('Ua')
                            },
                            {
                                name: 'B',
                                value: map.get('Ub')?map.get('Ub').toFixed(2):map.get('Ub')
                            },
                            {
                                name: 'C',
                                value: map.get('Uc')?map.get('Uc').toFixed(2):map.get('Uc')
                            },
                            // {name: '均', value: map.get('Vvavg')},
                        ]
                    }, {
                        title: '三相线电压',
                        unit: 'V',
                        isDangerous: ['Uab', 'Ubc', 'Uac', 'Vlavg'].includes(node),
                        value: [{
                                name: 'AB',
                                value: map.get('Uab')?map.get('Uab').toFixed(2):map.get('Uab')
                            },
                            {
                                name: 'BC',
                                value: map.get('Ubc')?map.get('Ubc').toFixed(2):map.get('Ubc')
                            },
                            {
                                name: 'AC',
                                value: map.get('Uac')?map.get('Uac').toFixed(2):map.get('Uac')
                            },
                            // {name: '均', value: map.get('Vlavg')},
                        ]
                    }, {
                        title: '电流',
                        unit: 'A',
                        isDangerous: ['Ia', 'Ib', 'Ic', 'Iavg'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('Ia')?map.get('Ia').toFixed(2):map.get('Ia')
                            },
                            {
                                name: 'B',
                                value: map.get('Ib')?map.get('Ib').toFixed(2):map.get('Ib')
                            },
                            {
                                name: 'C',
                                value: map.get('Ic')?map.get('Ic').toFixed(2):map.get('Ic')
                            },
                            // {name: '均', value: map.get('Iavg')},
                        ]
                    }, {
                        title: '有功功率',
                        unit: 'W',
                        isDangerous: ['PAa', 'PAb', 'PAc', 'PA'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('PAa')?map.get('PAa').toFixed(2):map.get('PAa')
                            },
                            {
                                name: 'B',
                                value: map.get('PAb')?map.get('PAb').toFixed(2):map.get('PAb')
                            },
                            {
                                name: 'C',
                                value: map.get('PAc')?map.get('PAc').toFixed(2):map.get('PAc')
                            },
                            // {name: '总', value: map.get('PA')}
                        ]
                    }, {
                        title: '无功功率',
                        unit: 'W',
                        isDangerous: ['PRa', 'PRb', 'PRc', 'PR'].includes(node),
                        value: [{
                                name: 'A',
                                value: map.get('PRa')?map.get('PRa').toFixed(2):map.get('PRa')
                            },
                            {
                                name: 'B',
                                value: map.get('PRb')?map.get('PRb').toFixed(2):map.get('PRb')
                            },
                            {
                                name: 'C',
                                value: map.get('PRc')?map.get('PRc').toFixed(2):map.get('PRc')
                            },
                            // {name: '总', value: map.get('PR')},
                        ]
                    }, {
                        title: '温度',
                        unit: '℃',
                        isDangerous: ['Temperature'].includes(node),
                        value: [{
                            name: 'T',
                            value: map.get('Temperature')
                        }, ]
                    }, {
                        title: '频率',
                        unit: 'Hz',
                        isDangerous: ['F'].includes(node),
                        value: [{
                            name: 'F',
                            value: map.get('F')
                        }, ]
                    }]
                }
             },
             // 获取报警详情数
            async getAccidentDetail(id) {
                let result = await Promise.all([GetAccidentDetailForId(id), GetAccidentValue(id)]);

                let result0 = this.transformForData(result[0]);
                let result1 = this.transformForData(result[1]);
                if (result0.details === null || result1.snapshot === null) {
                    return;
                }
                result0.details = this.accidentDetailMapper(result0.details)
                result1.snapshot = this.accidentValueMapper(result1.snapshot, result0.details.node,result0.details).filter((
                    item) => {
                    return item
                });

                // console.log(result0.details, result1.snapshot)
                return {
                    infomation: result0.details,
                    data: result1.snapshot
                };
            },
             // 判断状态码 取出data
            transformForData(response) {
                const {
                    code,
                    data,
                    status
                } = response.data;
                if (code !== 200 && status !== true) {
                    console.error('response error: code is not 200 or status is not true');
                    return null;
                }

                return data;
            },
             setCheck(alarmId){
                this.$confirm('确认处理该事件?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(async(action) => {
                        let result = await SetArticleCheck({
                            alarmId:alarmId
                        })
                        if(result.data.code==200){
                            this.$message({
                                message: '确认成功!',
                                type: 'success'
                            });
                            this.getData()
                        }
                    }).catch((action) => {
                        
                    });
            },
            // 站点改变
            async changeSite(areaId) {
                //console.log('选择站点：', areaId);
                this.areaId = areaId;
            },
            // 初始获取站点
            async getInitAreaId(areaId) {
                this.areaId = areaId;
            },
            async handleCurrentChange(val){
                let result = null
                if(this.classify=="Historical"){
                  result = await GetHistory({
                    areaId: this.areaId,
                        identTypeClass: this.searchData.identTypeClass,
                        IncidentClassificationClass:this.searchData.IncidentClassificationClass,
                        page: val,
                        size: this.size,
                        start: this.searchData.start,
                        end: this.searchData.end,
                    });
                }else{
                    result = await GetAlarmEvent({
                        areaId: this.areaId,
                        identTypeClass: this.searchData.identTypeClass,
                        IncidentClassificationClass:this.searchData.IncidentClassificationClass,
                        page: val,
                        size: this.size,
                        start: this.searchData.start,
                        end: this.searchData.end,
                    });
                }
                this.data = result.data.data.eventList.records
                this.ListInfo = result.data.data.eventList
            },
            // 获取当前报警类型下首页的数据
            async getData() {
                let result = null
                if(this.classify=="Historical"){
                    result = await GetHistory({
                    areaId: this.areaId,
                        identTypeClass: this.searchData.identTypeClass,
                        IncidentClassificationClass:this.searchData.IncidentClassificationClass,
                        page: 1,
                        size: this.size,
                        start: this.searchData.start,
                        end: this.searchData.end,
                    });
                }else{
                    result = await GetAlarmEvent({
                        areaId: this.areaId,
                        identTypeClass: this.searchData.identTypeClass,
                        IncidentClassificationClass:this.searchData.IncidentClassificationClass,
                        page: 1,
                        size: this.size,
                        start: this.searchData.start,
                        end: this.searchData.end,
                    });
                }
                this.data = result.data.data.eventList.records
                this.total = result.data.data.eventList.total
                this.ListInfo = result.data.data.eventList
            },
        },
        computed: {
            fengji: function () {
                if (this.$store.state.project.currentProject.projectId == 4) {
                    return "Temperature_status_windopen"
                    //  console.log(value)
                } else {
                    return "Fan_Status"
                    //  console.log(value)
                }
            },
            //合并多种改变, watch它重新获取数据
            reload: function () { 
                return {
                    classify:this.classify,
                    // searchData:this.searchData,
                    areaId: this.areaId,
                }
            },
            classify: function () {
                return this.$route.params.classify;
            },
        },
        watch: {
           // 重新获取数据
            reload: async function (val, oldVal) {
                this.getData()
            },
            searchData(n,o){
                this.getData()
            }
        }
    }
</script>

<style lang="less" scoped>
    .body {
        display: flex;
        flex-direction: column;
        height: 100%;
        background: #fff;
        position: relative;
        .table {
            flex: 1;
            overflow: hidden;
            //火狐隐藏滚动条
            scrollbar-width: none;

            ::-webkit-scrollbar {
                display: none;
            }
        }
    }
</style>